import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">人气排行</h2>
        <p className="section-subtitle">本周漫画阅读热度排行榜，看看大家都在追哪些热门作品</p>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200 comic-card-hover cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg font-heading font-bold text-lg md:text-xl bg-background-100 text-foreground-700">
                {item.rank <= 3 ? (
                  <span className={item.rank === 1 ? 'text-accent-500' : item.rank === 2 ? 'text-primary-500' : 'text-secondary-500'}>
                    {item.rank}
                  </span>
                ) : (
                  item.rank
                )}
              </div>

              <div className="flex-shrink-0 w-12 h-16 md:w-14 md:h-20 rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.heat}</p>
                <p className="text-xs text-primary-600 mt-1 font-medium">{item.update}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}